<template>
  <b-container>
    <b-row>
      <b-col class="pt-2">
        <label>User</label>
        <treeselect
          v-model="filters.user_id"
          :async="true"
          :load-options="searchUser"
          :defaultOptions="true"
          :normalizer="normalizerUser" />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Facility</label>
        <treeselect
          v-model="filters.facilities_id"
          :async="true"
          :load-options="searchFacility"
          :defaultOptions="true"
          :normalizer="normalizer"
          multiple />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Facility</label>
        <treeselect
          v-model="filters.facility_id"
          :async="true"
          :load-options="searchFacility"
          :defaultOptions="true"
          :normalizer="normalizer"
          placeholder="Opcional · alternativa a varias facilities" />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Doctor</label>
        <treeselect
          v-model="filters.doctor_id"
          :async="true"
          :load-options="searchDoctor"
          :defaultOptions="true"
          :normalizer="normalizerUser" />
      </b-col>
      <div class="separacion w-100"></div>
    </b-row>
    <b-row>
      <b-col class="pt-2">
        <label>Rol</label>
        <treeselect
          v-model="filters.rol_id"
          :options="rolOptions"
          :normalizer="normalizer">
        </treeselect>
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>Start date</label>
        <flat-pickr
          v-model="filters.start_date"
          :config="config"
          class="form-control"
          placeholder="MM-DD-YYYY"
          type="date" />
      </b-col>
      <div class="separacion w-100"></div>
      <b-col class="pt-2">
        <label>End date</label>
        <flat-pickr
          v-model="filters.end_date"
          :config="configEnd"
          class="form-control"
          placeholder="MM-DD-YYYY"
          type="date" />
      </b-col>
      <b-col cols="12" class="mb-md-0 mb-2 mt-2" align="end">
        <b-button variant="secondary" @click="seeCuponsBool = true" class="mr-1">
          See cupons
        </b-button>
        <b-button variant="info" @click="seeCompareFacilities = true" class="mr-1">
          Compare facilities
        </b-button>
        <b-button variant="success" @click="emitExcel" class="mr-1">
          <span v-if="!loadingExcel">Excel</span>
          <span v-else>
            <SpinnerLoading />
          </span>
        </b-button>
        <b-button variant="warning" @click="resetFilter" class="mr-1"> Clear </b-button>
        <b-button variant="primary" @click="handleFormSubmit()" :disabled="loadingSearh">
          <span v-if="!loadingSearh">Search</span>
          <span v-else>
            <SpinnerLoading />
          </span>
        </b-button>
      </b-col>
    </b-row>
    <compareFacilities :seeCompareFacilities.sync="seeCompareFacilities" />
    <ToastNotification ref="toast" />
    <Cupons
      ref="tablarda"
      :tableData="tableData"
      @paginated="cuponsPage = $event"
      :seeCupons.sync="seeCupons"
      @sendDataTable="dataTable = $event" />
    <SeeCupons
      :cupons="cupons"
      :isCuponsModalActive.sync="seeCuponsBool"
      @closeModalCupons="closeModalCupons"
      @changePage="cuponsPage = $event" />

    <ProgressiveLoader
      :showLoader="showLoader"
      :currentProgress="loader.currentProgress"
      :totalMonths="loader.totalMonths"
      :currentMonth="loader.currentMonth"
      :currentYear="loader.currentYear"
      :allowCancel="loader.allowCancel"
      @cancel="cancelProgressiveLoading"
    />
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'

import SpinnerLoading from '@/components/SpinnerLoading'
import ToastNotification from '@/components/ToastNotification'
import axios from '@/core/services/apiInsurance/admin/adminData'
import progressiveInsuranceAdminDataLoader from '@/core/services/apiInsurance/admin/progressiveAdminDataLoader'
import axiosU from '@/core/services/apiInsurance/admin/user'
import axiosR from '@/core/services/apiInsurance/admin/roles'
import axiosF from '@/core/services/apiInsurance/admin/facilities'
import compareFacilities from './compareFacilities.vue'
import Cupons from './cupons.vue'
import SeeCupons from './seeCupons.vue'
import ProgressiveLoader from '@/view/pages/dashboard/components/ProgressiveLoader.vue'

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BButton,
    SpinnerLoading,
    ToastNotification,
    compareFacilities,
    Cupons,
    SeeCupons,
    ProgressiveLoader,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    page: {
      type: Number,
      default: 1,
      required: true,
    },
  },
  data() {
    return {
      rolOptions: [],
      seeCuponsBool: false,
      loadingExcel: false,
      loadingSearh: false,
      cupons: [],
      showLoader: false,
      loader: {
        currentProgress: 0,
        totalMonths: 0,
        currentMonth: 0,
        currentYear: 0,
        allowCancel: true,
      },
      filters: {
        user_id: null,
        facilities_id: null,
        facility_id: null,
        doctor_id: null,
        rol_id: null,
        end_date: null,
        start_date: null,
        data_excel: false,
      },
      config: {
        dateFormat: 'm-d-Y H:i:S',
        enableSeconds: true,
        allowInput: true,
        enableTime: true,
      },
      configEnd: {
        dateFormat: 'm-d-Y H:i:S',
        enableSeconds: true,
        allowInput: true,
        enableTime: true,
      },
      tableData: {},
      dataExcel: {},
      seeCompareFacilities: false,
      seeCupons: false,
      normalizer(node) {
        return {
          id: node.id,
          label: node.name,
        }
      },
      normalizerUser(node) {
        return {
          id: node.id,
          label: `${node.name} ${node.lastname}`,
        }
      },
      cuponsPage: 1,
    }
  },
  async created() {
    const firstDate = `${new Date().getMonth() + 1}-${new Date().getDate()}-${new Date().getFullYear()}`

    this.filters.start_date = `${firstDate} 09:00:00`
    this.filters.end_date = `${firstDate} 22:00:00`

    axiosR.rolesList().then(({ data }) => (this.rolOptions = data))

    this.searchFilter()

    // axios.getAdminData(this.filters).then(({ data }) => {
    //     console.log(data);
    //     this.$emit("getItems", data);
    // });
  },
  watch: {
    page() {
      if (this.isProgressiveResult()) {
        this.loadProgressivePage(this.page, { rows: true })
        return
      }
      axios
        .getAdminDataPaginated(this.page, this.filtersForApi(), { throwOnError: true })
        .then(({ data }) => {
          data.user = this.filters.user_id
          data.dates = {
            end_date: this.filters.end_date,
            start_date: this.filters.start_date,
          }
          this.setCupons(data['CAMPAIGN_CUPONS'])
          this.sendData(data)
        })
        .catch(error => this.showApiError(error))
    },
    cuponsPage() {
      if (this.isProgressiveResult()) {
        this.loadProgressivePage(this.cuponsPage, { rows: false, campaigns: true })
        return
      }
      axios
        .getAdminDataPaginated(this.cuponsPage, this.filtersForApi(), { throwOnError: true })
        .then(({ data }) => {
          data.user = this.filters.user_id
          data.dates = {
            end_date: this.filters.end_date,
            start_date: this.filters.start_date,
          }
          this.setCupons(data['CAMPAIGN_CUPONS'])
          this.tableData = data
        })
        .catch(error => this.showApiError(error))
    },
    // filters: {
    //   handler() {
    //     this.searchFilter()
    //   },
    //   deep: true,
    // },
  },
  methods: {
    filtersForApi() {
      return { ...this.filters }
    },
    showApiError(error) {
      const message = error?.response?.data?.message
      this.$refs.toast?.danger?.(message || 'An unexpected error has been ocurred!')
    },
    /** El resultado en pantalla vino de una carga progresiva (rango de más de un mes). */
    isProgressiveResult() {
      const dates = this.tableData?.dates
      if (!dates?.start_date || !dates?.end_date) return false
      return (
        progressiveInsuranceAdminDataLoader.calculateMonthsBetween(dates.start_date, dates.end_date) > 1
      )
    },
    /** Cambia de página sin pedir el rango completo, que el backend no responde. */
    async loadProgressivePage(page, targets) {
      try {
        const result = await progressiveInsuranceAdminDataLoader.loadPage(page, targets)
        const data = { ...this.tableData }
        if (result.ROWS_PAGINATE) data.ROWS_PAGINATE = result.ROWS_PAGINATE
        if (result.CAMPAIGN_CUPONS) {
          const campaigns = { ...(data.CAMPAIGN_CUPONS || {}) }
          Object.entries(result.CAMPAIGN_CUPONS).forEach(([key, value]) => {
            campaigns[key] = { ...(campaigns[key] || {}), CUPONS_PAGINATE: value.CUPONS_PAGINATE }
          })
          data.CAMPAIGN_CUPONS = campaigns
          this.setCupons(campaigns)
        }
        if (targets.rows) this.sendData(data)
        else this.tableData = data
      } catch (error) {
        this.showApiError(error)
      }
    },
    setCupons(campaign_cupons) {
      const newCupons = []
      Object.entries(campaign_cupons).forEach(([key, value]) => {
        value.title = key
        newCupons.push(value)
      })
      this.cupons = newCupons
      //   console.log('cupones:', this.cupons)
    },
    closeModalCupons() {
      this.seeCuponsBool = false
    },
    sendData(data) {
      this.tableData = data
      this.$emit('getItems', data)
    },
    /**
     * Rangos de más de un mes: todo se carga mes a mes y se une en el front,
     * porque la petición con el rango completo la corta el servidor.
     */
    async runProgressiveSearch(isSearch) {
      this.showLoader = true
      this.loader.allowCancel = true

      progressiveInsuranceAdminDataLoader.onProgress(({ current, total, currentMonth, currentYear }) => {
        this.loader.currentProgress = current
        this.loader.totalMonths = total
        this.loader.currentMonth = currentMonth
        this.loader.currentYear = currentYear
      })

      try {
        const data = await progressiveInsuranceAdminDataLoader.loadProgressiveData(
          this.filtersForApi(),
          !isSearch
        )
        data.facility = this.filters.facilities_id
        data.user = this.filters.user_id
        data.dates = {
          end_date: this.filters.end_date,
          start_date: this.filters.start_date,
        }

        if (!isSearch) this.$emit('dataExcel', data)
        this.setCupons(data['CAMPAIGN_CUPONS'] || {})
        this.sendData(data)
        if (!isSearch) {
          this.dataExcel = data
          this.$emit('getExcel')
        }
      } catch (error) {
        if (String(error?.message) !== 'ABORTED_BY_USER') this.showApiError(error)
      } finally {
        this.loadingSearh = false
        this.loadingExcel = false
        this.showLoader = false
      }
    },
    cancelProgressiveLoading() {
      progressiveInsuranceAdminDataLoader.requestAbort()
      this.loader.allowCancel = false
    },
    handleFormSubmit() {
      if (this.validateForm()) {
        this.searchFilter()
      }
    },
    validateForm() {
      const { start_date, end_date } = this.filters
      const isValid = start_date !== null && end_date !== null
      //   console.log('isValid', isValid)
      return isValid
    },
    searchFilter(isExcel = true) {
      if (isExcel) this.filters['data_excel'] = false
      if (!this.validateForm()) return null

      if (!isExcel) this.loadingExcel = true
      if (isExcel) this.loadingSearh = true

      if (!this.filters.start_date || !this.filters.end_date) {
        if (!isExcel) this.loadingExcel = false
        if (isExcel) this.loadingSearh = false
        return this.$refs.toast.warning('Check the dates!')
      }

      const monthsBetween = progressiveInsuranceAdminDataLoader.calculateMonthsBetween(
        this.filters.start_date,
        this.filters.end_date
      )
      if (monthsBetween > 1) {
        this.runProgressiveSearch(isExcel)
        return
      }

      axios
        .getAdminData(this.filtersForApi(), { throwOnError: true })
        .then(({ data }) => {
          if (data) {
            data.facility = this.filters.facilities_id
            data.user = this.filters.user_id
            data.dates = {
              end_date: this.filters.end_date,
              start_date: this.filters.start_date,
            }
            
            if (!isExcel) this.$emit('dataExcel', data)
            this.setCupons(data['CAMPAIGN_CUPONS'])
            this.sendData(data)
          }

          if (isExcel) this.loadingSearh = false
          if (!isExcel) this.loadingExcel = false
          if (!isExcel) this.tableData = data
          if (!isExcel) this.dataExcel = data
          if (!isExcel) this.$emit('getExcel')
          // console.log(data)
        })
        .catch(error => {
          if (isExcel) this.loadingSearh = false
          if (!isExcel) this.loadingExcel = false
          this.showApiError(error)
        })
    },
    emitExcel() {
      this.filters['data_excel'] = true
      this.searchFilter(false)
    },
    resetFilter() {
      const filter = this.filters
      for (const iterator in filter) {
        this.filters[iterator] = null
      }
    },
    searchUser({ action, searchQuery, callback }) {
      if (action === 'ASYNC_SEARCH') {
        const datos = {
          name: searchQuery,
        }
        axiosU.userFilter(10, datos).then(({ registro: { data } }) => {
          callback(null, data)
        })
      }
    },
    searchDoctor(args) {
      this.searchUser(args)
    },
    searchFacility({ action, searchQuery, callback }) {
      if (action === 'ASYNC_SEARCH') {
        const datos = {
          name: searchQuery,
        }
        axiosF.facilityFilter(30, datos).then(({ data }) => {
          callback(null, data)
        })
      }
    },
  },
}
</script>

<style>
@media (min-width: 970px) {
  .separacion {
    display: none;
  }
}
</style>
